class filters {
    constructor(
     id,
     name,
     operId,
     defaults,
     created,
     data

    
    
    ){
        this.id = id
        this.name = name
        this.operId= operId
        this.defaults=defaults
        this.created=created
        this.data=data
      

    
    }
    static fromJson({
        FiltroId,
        Nombre,
        OperId,
        Defecto,
        CreadoEl,
        Data  
    }){
        return new filters(
            FiltroId,
            Nombre,
            OperId,
            Defecto,
            CreadoEl,
            Data

            
        )
    }

    }
    export default filters